import HomeView from './home/HomeView'
import ChaptersRootView from './chapters/ChaptersRootView'
import PageView from './page/PageView'
import EndtestRootView from './endtest/EndtestRootView'

export const Views = {
  Home: HomeView,
  Chapters: ChaptersRootView,
  Page: PageView,
  Endtest: EndtestRootView,
}